import React, { useState } from 'react';

interface OrganizationLogoProps {
  logoUrl?: string | null;
  organizationName?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const OrganizationLogo: React.FC<OrganizationLogoProps> = ({
  logoUrl,
  organizationName = 'Growth Energy',
  size = 'md',
  className = ''
}) => {
  const [imageError, setImageError] = useState(false);

  // Size classes for initials fallback (circular)
  const initialsSizeClasses = {
    sm: 'w-12 h-12 text-lg',
    md: 'w-16 h-16 text-xl',
    lg: 'w-20 h-20 text-2xl'
  };

  // Max height for logo images (allows full width, constrains height)
  const logoMaxHeight = {
    sm: 'max-h-12',
    md: 'max-h-16',
    lg: 'max-h-24'
  };

  const initialsClass = initialsSizeClasses[size];
  const logoHeightClass = logoMaxHeight[size];

  // If logo URL is provided and no error, show the image
  if (logoUrl && !imageError) {
    return (
      <div className={`flex items-center justify-center ${className}`}>
        <img
          src={logoUrl}
          alt={`${organizationName} logo`}
          className={`${logoHeightClass} w-auto object-contain`}
          onError={() => setImageError(true)}
        />
      </div>
    );
  }

  // Default: Show organization initials in a circle
  const initials = organizationName
    .split(' ')
    .map(word => word[0])
    .join('')
    .substring(0, 2)
    .toUpperCase();

  return (
    <div className={`${initialsClass} bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center ${className}`}>
      <span className="text-white font-bold">{initials}</span>
    </div>
  );
};

export default OrganizationLogo;
